<template>
  <div>
    <v-toolbar dense flat>
      <v-toolbar-title>
        <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
      </v-toolbar-title>
    </v-toolbar>

    <v-container fluid class="justify-center">
      <d-header label="New Image" />
      <v-row justify="space-between" class="pb-2">
        <g-button label="Cancel" @onclick="goback" />
        <h3 class="headline white--text">Image</h3>
        <g-button type="primary" label="Create" @onclick="create" />
      </v-row>

      <d-no-display label="(No images to display)" />

      <upload-dialog v-model="dialog" :isimg="true" :upload-in-progress="uploadInProgress" @upload="onUpload" />
    </v-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      breadcrumbs: [
        {
          text: "Database",
          to: { name: "database" },
        },
        {
          text: "Images",
          to: { name: "database_view", params: { view: "images", sub: "ALL" } },
        },
        {
          text: "New",
        },
      ],
      dialog: false,
      uploadInProgress: false,
      name: "",
      disabled: false,
    };
  },
  computed: {},
  methods: {
    goback() {
      this.$router.push({ name: "database_view", params: { view: "images", sub: "ALL" } });
    },
    create() {
      this.dialog = true;
    },
    onUpload(images) {
      if (!images || images.length === 0) return;
      const image = images[0];
      this.uploadInProgress = true;
      return this.$store
        .dispatch("StorageStore/uploadFile", {
          name: image.description,
          file: image.upload,
        })
        .then((data) => {
          return this.$store.dispatch("ImageStore/addImage", {
            description: image.description,
            key: data.key,
          });
        })
        .then((id) => {
          this.$root.$success("Created image");
          this.$router.push({
            name: "image_info",
            params: {
              id: id,
            },
          });
        })
        .catch((err) => {
          this.$root.$error(err);
        })
        .finally(() => {
          this.uploadInProgress = false;
          this.dialog = false;
        });
    },
  },
  mounted() {},
};
</script>
